// extracted by mini-css-extract-plugin
export default {"esim_dialog":"EsimPaymentSuccess_esim_dialog__Q-583","customer_service_text":"EsimPaymentSuccess_customer_service_text__enV1W"};